import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';

@Injectable()
export class InstallationFreeTextPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateFreeText(inspectionId: string, pointId: string, pluginId: string, textes: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, textes).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, textes: any[]): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, textes, 'Textes').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
